import React from 'react'
import BedbankSearchTileWalledContent from './BedbankSearchTileWalledContent'
import BedbankSearchTileSignUpButton from './BedbankSearchTileSignUpButton'
import { EmptyObject } from 'lib/object/objectUtils'
import SearchTilePrimaryActionButton from '../shared/SearchTilePrimaryActionButton'
import TextButton from 'LuxKit/Button/TextButton'
import { checkBypassMode } from 'marketing/lib/lib'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  filters?: App.OfferListFilters
  utmBp?: string
  onSelectDatesClick?: () => void
  hidePricing?: boolean
}

function BedbankSearchTileAction({
  offer,
  filters = EmptyObject,
  utmBp,
  onSelectDatesClick,
  hidePricing = false
}: Props) {
  // Only on bedbank titles when bp=2 is set and the user isn't logged in. Clicking on "Login for member savings" triggers the login modal.
  const isLoginForMemberSavings = checkBypassMode(utmBp)
  const hidePrice = hidePricing || offer.hidePricing

  const handleSelectDatesClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (hidePrice && onSelectDatesClick) {
      e.preventDefault()
      onSelectDatesClick()
    }
  }

  const actionButton = hidePrice && onSelectDatesClick ? (
    <TextButton nonInteractable kind="primary" onClick={handleSelectDatesClick}>
      Select dates
    </TextButton>
  ) : (
    <SearchTilePrimaryActionButton />
  )

  return <BedbankSearchTileWalledContent
    wall={<BedbankSearchTileSignUpButton isLoginForMemberSavings={isLoginForMemberSavings} />}
    offer={offer}
    filters={filters}
    hidePricing={hidePrice}
  >
    {actionButton}
  </BedbankSearchTileWalledContent>
}

export default BedbankSearchTileAction
